import React, { Component } from "react";
import PropTypes from "prop-types";

class Checkbox extends Component {
	constructor(props) {
		super(props);

		this.state = {
			options: props.options
		};

		this.handleChange = this.handleChange.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ options: nextProps.options });
	}

	handleChange(e) {
		const item = e.target.name;

		this.setState({
			options: this.state.options.filter(val => {
				if (val.name == item || val.value == item) {
					val.checked = !val.checked;
				}
				return val;
			})
		});

		// OnChange
		this.props.onChange(this.state.options);
	}

	render() {
		let mountedOptions = [];
		let dataAction = this.props.hasOwnProperty("data-action")
			? this.props["data-action"]
			: "offers-checkbox";
		this.state.options.forEach((option, index) => {
			mountedOptions.push(
				<label key={option.name} className="checkbox-component__container">
					<div className={option.textStyle}>{option.label}</div>
					<input
						className="checkbox-component__container--input"
						type="checkbox"
						checked={option.checked}
						name={option.name || option.value}
						onChange={this.handleChange}
					/>
					<span className="checkbox-component__container--span" />
				</label>
			);
		});

		return (
			<div className="checkbox-component" data-action={dataAction}>
				{mountedOptions}
			</div>
		);
	}
}

Checkbox.propTypes = {
	options: PropTypes.array.isRequired,
	onChange: PropTypes.func
};

export default Checkbox;
